import * as React from 'react';
import { UIHeading1, UIText1 } from '@cian/ui-kit';

import * as style from './style.css';

export interface ICompareHubPageProps {
  onNewbuildingsClick(): void;
  onOffersClick(): void;
}

export const CompareHubPage = ({ onNewbuildingsClick, onOffersClick }: ICompareHubPageProps) => {
  return (
    <main className={style['container']} data-testid="compare-hub_page">
      <UIHeading1 textAlign="center" as="h1">
        Сравнение
      </UIHeading1>
      <nav className={style['links']}>
        <a
          className={style['link']}
          data-testid="compare-hub-offers_link"
          href="/compare/?activeTab=offers"
          onClick={onOffersClick}
        >
          <UIText1>Сравнение квартир</UIText1>
        </a>
        <a
          className={style['link']}
          data-testid="compare-hub-newbuildings_link"
          href="/compare/?activeTab=newbuildings"
          onClick={onNewbuildingsClick}
        >
          <UIText1>Сравнение ЖК</UIText1>
        </a>
      </nav>
    </main>
  );
};
